import React, { useMemo } from "react";
import Table from "~/components/Table";
import clsx from "clsx";
import s from "~/pages/SRR/SRR.less";
import {
  customHeaderByAverageCarAge,
  customHeaderByAverageCarAgeItog,
  getCustomTableBody,
} from "~/pages/SRR/utils/getCustomTable";
import { useTranslation } from "react-i18next";

interface ReportServiceTable {
  items;
  reportConfigData;
}

const ReportNSByAverageCarAgeTable = ({
  items,
  reportConfigData,
}: ReportServiceTable) => {
  const { t } = useTranslation();
  const { rows, average } = items;

  const rowsItem = rows ? rows : [];
  const customHeaderAverageCarAge = useMemo(
    () => customHeaderByAverageCarAge("ReportNSByAverageCarAge", rowsItem, t),
    ["ReportNSByAverageCarAge", rowsItem]
  );
  const customHeaderAverageCarAgeItog = useMemo(
    () => customHeaderByAverageCarAgeItog("ReportNSByAverageCarAgeItog", t),
    ["ReportNSByAverageCarAgeItog", rowsItem]
  );

  const resultOne = average?.carOwnershipByChange
    ? average?.carOwnershipByChange.map((el) => {
        return {
          ownershipPeriodFromOne: el.ownershipPeriodFrom,
          ownershipPeriodToOne: el.ownershipPeriodTo,
          carsTotalOne: el.carsTotal,
        };
      })
    : [];

  const resultTwo = average?.carOwnershipByChange
    ? average?.carOwnershipByChange.map((el) => {
        return {
          ownershipPeriodFromTwo: el.ownershipPeriodFrom,
          ownershipPeriodToTwo: el.ownershipPeriodTo,
          carsTotalTwo: el.carsTotal,
        };
      })
    : [];

  const mergedArray = resultOne.map((obj, index) => {
    return { ...obj, ...resultTwo[index] };
  });

  return (
    <>
      {rowsItem.length > 0 && (
        <Table
          options={[]}
          items={rowsItem}
          reportSelect={"ReportNSByAverageCarAge"}
          sortable={false}
          positionStiki
          type={"srr-custom"}
          customClassName={clsx(s.dealers_table, {})}
          customHeader={customHeaderAverageCarAge}
          TableBodyComponent={getCustomTableBody("ReportNSByAverageCarAge")}
        />
      )}
      {mergedArray.length > 0 && (
        <Table
          options={[]}
          items={mergedArray}
          reportSelect={"ReportNSByAverageCarAgeItog"}
          sortable={false}
          positionStiki
          type={"srr-custom"}
          customClassName={clsx(s.dealers_table, {})}
          customHeader={customHeaderAverageCarAgeItog}
          TableBodyComponent={getCustomTableBody("ReportNSByAverageCarAgeItog")}
        />
      )}
    </>
  );
};

export default ReportNSByAverageCarAgeTable;
